import { createRequestTypes } from "../../utils";

// Fetch all quizzes
export const FETCH_QUIZZES = createRequestTypes("FETCH_QUIZZES");
export const fetchQuizzesRequest = () =>
  ({ type: FETCH_QUIZZES.REQUEST });
export const fetchQuizzesSuccess = (payload) =>
  ({ type: FETCH_QUIZZES.SUCCESS, payload });
export const fetchQuizzesFailure = (error) =>
  ({ type: FETCH_QUIZZES.FAILURE, payload: { error } });

// Fetch single quiz by ID
export const FETCH_QUIZ = createRequestTypes("FETCH_QUIZ");
export const fetchQuizRequest = (quizId) =>
  ({ type: FETCH_QUIZ.REQUEST, payload: { quizId } });
export const fetchQuizSuccess = (payload) =>
  ({ type: FETCH_QUIZ.SUCCESS, payload });
export const fetchQuizFailure = (error) =>
  ({ type: FETCH_QUIZ.FAILURE, payload: { error } });

// Fetch quiz questions
export const FETCH_QUIZ_QUESTIONS = createRequestTypes("FETCH_QUIZ_QUESTIONS");
export const fetchQuizQuestionsRequest = (quizId, numQuestions = 10) =>
  ({ type: FETCH_QUIZ_QUESTIONS.REQUEST, payload: { quizId, numQuestions } });
export const fetchQuizQuestionsSuccess = (payload) =>
  ({ type: FETCH_QUIZ_QUESTIONS.SUCCESS, payload });
export const fetchQuizQuestionsFailure = (error) =>
  ({ type: FETCH_QUIZ_QUESTIONS.FAILURE, payload: { error } });

// Start quiz attempt
export const START_QUIZ_ATTEMPT = createRequestTypes("START_QUIZ_ATTEMPT");
export const startQuizAttemptRequest = (quizId, numQuestions = 10) =>
  ({ type: START_QUIZ_ATTEMPT.REQUEST, payload: { quizId, numQuestions } });
export const startQuizAttemptSuccess = (payload) =>
  ({ type: START_QUIZ_ATTEMPT.SUCCESS, payload });
export const startQuizAttemptFailure = (error) =>
  ({ type: START_QUIZ_ATTEMPT.FAILURE, payload: { error } });

// Submit answer
export const SUBMIT_ANSWER = createRequestTypes("SUBMIT_ANSWER");
export const submitAnswerRequest = (attemptId, questionId, optionId) =>
  ({ type: SUBMIT_ANSWER.REQUEST, payload: { attemptId, questionId, optionId } });
export const submitAnswerSuccess = (payload) =>
  ({ type: SUBMIT_ANSWER.SUCCESS, payload });
export const submitAnswerFailure = (error) =>
  ({ type: SUBMIT_ANSWER.FAILURE, payload: { error } });

// Complete quiz attempt
export const COMPLETE_QUIZ_ATTEMPT = createRequestTypes("COMPLETE_QUIZ_ATTEMPT");
export const completeQuizAttemptRequest = (attemptId) =>
  ({ type: COMPLETE_QUIZ_ATTEMPT.REQUEST, payload: { attemptId } });
export const completeQuizAttemptSuccess = (payload) =>
  ({ type: COMPLETE_QUIZ_ATTEMPT.SUCCESS, payload });
export const completeQuizAttemptFailure = (error) =>
  ({ type: COMPLETE_QUIZ_ATTEMPT.FAILURE, payload: { error } });

// Fetch user attempts
export const FETCH_USER_ATTEMPTS = createRequestTypes("FETCH_USER_ATTEMPTS");
export const fetchUserAttemptsRequest = () =>
  ({ type: FETCH_USER_ATTEMPTS.REQUEST });
export const fetchUserAttemptsSuccess = (payload) =>
  ({ type: FETCH_USER_ATTEMPTS.SUCCESS, payload });
export const fetchUserAttemptsFailure = (error) =>
  ({ type: FETCH_USER_ATTEMPTS.FAILURE, payload: { error } });

// Fetch attempt details
export const FETCH_ATTEMPT_DETAILS = createRequestTypes("FETCH_ATTEMPT_DETAILS");
export const fetchAttemptDetailsRequest = (attemptId) =>
  ({ type: FETCH_ATTEMPT_DETAILS.REQUEST, payload: { attemptId } });
export const fetchAttemptDetailsSuccess = (payload) =>
  ({ type: FETCH_ATTEMPT_DETAILS.SUCCESS, payload });
export const fetchAttemptDetailsFailure = (error) =>
  ({ type: FETCH_ATTEMPT_DETAILS.FAILURE, payload: { error } });

// Fetch categories
export const FETCH_CATEGORIES = createRequestTypes("FETCH_CATEGORIES");
export const fetchCategoriesRequest = () =>
  ({ type: FETCH_CATEGORIES.REQUEST });
export const fetchCategoriesSuccess = (payload) =>
  ({ type: FETCH_CATEGORIES.SUCCESS, payload });
export const fetchCategoriesFailure = (error) =>
  ({ type: FETCH_CATEGORIES.FAILURE, payload: { error } });

// Local actions (no API calls)
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const setCurrentQuestion = (questionIndex) =>
  ({ type: SET_CURRENT_QUESTION, payload: { questionIndex } });

export const RESET_QUIZ_STATE = "RESET_QUIZ_STATE";
export const resetQuizState = () =>
  ({ type: RESET_QUIZ_STATE });

export const SET_SELECTED_OPTION = "SET_SELECTED_OPTION";
export const setSelectedOption = (questionId, optionId) =>
  ({ type: SET_SELECTED_OPTION, payload: { questionId, optionId } });
